const overrides = (palette, typography) => ({
  button: {
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)"
    }
  }
})

export default overrides
